
import urlbase from './baseIp.js';
const URL = urlbase;

const prefix =  URL + '/sys/';
const prefix1 = URL + '/task/';
const prefix2 = URL + '/thailand/';
const prefix3 = URL + '/management/';
const prefix4 =  URL + '/standard/';
const prefix5 =  URL + '/company/';
const prefix6 = URL +'/cnCdStock/';
const prefix7 = URL +'/baseInfo/';

const url1 = {
    // 注册
    login: prefix + 'login',
    //登出
    logout: prefix + 'logout',
    test:prefix + 'test',
    //改密码
    changePwd:prefix + 'changePwd',
    //万华物料信息
    getGoodsInfo:prefix1 + 'getGoodsInfo',
    // 插入明细时进行物料查询
    getGoods:prefix1 + 'getGoods',
    // 万华任务查询
    findTask:prefix1 + 'findTask',
    // 创建emst任务
    pushTask:prefix1+ 'pushTask',
    // 变更任务状态
    // changeStatus:prefix1 + 'changeStatus',
    // 删除任务
    deleteTask:prefix1 + 'deleteTask',
    // 收货确认
    sign: prefix1 + 'sign',
    // 根据登录用户名获取菜单列表
    getMenusByUser:prefix + 'getMenusByUser',
    // 根据名字模糊查询收发货人-泰国申报要素
    getConsigneeByName:prefix2 + 'getConsigneeByName',
    // 新增收发货人泰国申报要素
    addConsignee:prefix2 + 'addConsignee/',
    // 读取文件
    readFile:prefix2 + 'readFile',
    // 根据角色获取权限列表
    getModuleList:prefix + 'getModuleList',
    // 新增或修改模块
    insModule: prefix + 'insModule',
    // 返回所有角色列表
    getRoleList:prefix + 'getRoleList',
    // 新增或修改角色
    insRole:prefix + 'insRole',
    // 获取所有用户
    getUserList:prefix + 'getUserList',
    // 新增或修改用户
    insUser:prefix + 'insUser',
    // 根据用户名获取角色列表
    getRoleByUser:prefix + 'getRoleByUser',
    // 更新用户角色关联
    insRelations:prefix + 'insRelations',
    // 测试动态表格列
    getDynamicTable:prefix + 'getDynamicTable',
    // 批量新增申报要素
    insElements:prefix2 + 'insElements',
    // 根据名称检索港口列表
    getPortNameBy:prefix2 + 'getPortNameBy',
    // 获取所有员工电脑信息
    management:prefix3 + 'getAll',
    // 获取树形菜单
    getTreeMenuList:prefix + 'getTreeMenuList',
    // 更新角色的权限
    updateModuleByRole:prefix + 'updateModuleByRole',
    // 删除模块
    deleteById:prefix + 'deleteById',
    // 用户配置自定义列
    pushUserProfile : prefix4 + 'pushUserProfile',
    // 根据用户名获取自定义列设置
    getUserProfile:prefix4 + 'getUserProfile',
    // 获取公司信息列表
    getCompanyList:prefix5 + 'getCompanyList',
    //保存/编辑公司信息
    saveOrUpdateCompany:prefix5 + 'saveOrUpdateCompany',
    //删除公司
    deleteCompany:prefix5 + 'deleteCompany',
    //获取建发库存日志
    getCdLog:prefix6 +'getCdLog',
    // 获取东胜-建发可用库存
    getDongShengStock:prefix6 +'getDongShengStock',
    //获取东胜-建发出库信息
    getDongShengOutInfo:prefix6+ 'getDongShengOutInfo',
    //获取东胜-建发入库信息
    getDongShengInInfo:prefix6 +'getDongShengInInfo',
    //获取司机信息
    getDriverByName:prefix7 + 'getDriverByName',
    //新增司机信息
    insOrUpdateDriver:prefix7 + 'insOrUpdateDriver',
    //更改司机状态
    changeDriverStatus:prefix7 + 'changeDriverStatus',
    getInfosByName:prefix7 + 'getInfosByName',
    //新增车辆信息
    insOrUpdateVehicle:prefix7 + 'insOrUpdateVehicle',
    changeStatus:prefix7 + 'changeStatus',
    changeDriver:prefix7 + 'changeDriver',
    // 分页查询地址
    getPortsBy:prefix7 + 'getPortsBy',
    //  新增修改送货地址
    insOrUpdatePort:prefix7 + 'insOrUpdatePort',
}
export default url1